<template>
  <div class="projects-requests-header">
    <span class="switch-wrapper">
      <span class="proj tab" :class="{ active: currentRoute === VS.ACTIVITY_LOG }" @click="onSwitchClicked(VS.ACTIVITY_LOG)">
        <label>{{ $t('active') }}</label>
      </span>
      <span class="req tab" :class="{ active: currentRoute === VS.REQUESTS }" @click="onSwitchClicked(VS.REQUESTS)">
        <label>{{ $t('requests') }} ({{ inRequestedStatus }})</label>
      </span>
    </span>
  </div>
</template>

<script>
import { views } from '@/router/constants';
import { LOAD_PROJECTS } from '@/store/project/actionTypes';
import { LOAD_REQUESTS } from '@/store/request/actionTypes';

const loadActions = {
  [views.ACTIVITY_LOG]: LOAD_PROJECTS,
  [views.REQUESTS]: LOAD_REQUESTS,
};

export default {
  name: 'ProjectsRequestsHeader',
  props: {
    inRequestedStatus: Number,
  },
  computed: {
    VS() {
      return views;
    },
    currentRoute() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    onSwitchClicked(route) {
      this.$store.dispatch(loadActions[route]);
      this.$router.push({ name: route });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.projects-requests-header {
  display: flex;
  margin-left: $space-12;
  margin-top: $space-8;
  text-align: center;
  margin-bottom: $space-10;

  .switch-wrapper {
    display: inline-block;
    height: rem(34);
    line-height: $font-size-base;

    border: $border-width-thin solid var(--border-primary);
    border-radius: $radius-sm;
    background-color: var(--bg-primary);
  }

  span {
    label {
      position: relative;
      top: rem(8);
    }
  }

  .proj {
    width: rem(71);
  }
  .req {
    width: rem(106);
  }

  .tab {
    cursor: pointer;

    label {
      cursor: pointer;
    }

    display: inline-block;

    box-sizing: border-box;
    height: $btn-height-md;

    color: var(--text-secondary);
    font-size: $font-size-base;
    font-weight: 500;
    letter-spacing: 0;
    line-height: $font-size-base;
  }

  .active {
    border: $border-width-thin solid var(--brand-primary);
    border-radius: $radius-sm;
    background-color: var(--brand-primary);
    color: var(--text-inverse);
  }
}
</style>
